<template>
	<div class="container app_manage_page">
		<!-- 顶部 -->
		<page-top></page-top>
		<!-- 顶部 end -->

		<div style="position: relative;z-index: 9;width: 100%;height: 100%;padding-left: 220px;background: #f7f7f7;">
			<!-- 侧边导航 -->
			<side-menu></side-menu>
			<!-- 侧边导航 end-->
			
			<!-- 子路由 -->
			<router-view></router-view>
			<!-- 子路由 end -->
		</div>
	</div>
</template>

<script>
	import PageTop from './components/page_top.vue';
	import SideMenu from './components/side_menu.vue';
	
	export default {
		components: {
			PageTop,
			SideMenu
		}
	}
</script>

<style scoped>
	.app_manage_page{ padding: 50px 0 0 0; }
</style>
